// extracted by mini-css-extract-plugin
export default {"input":"O8-z","button":"P8-z","selected":"Q8-z","unavailable":"R8-z","oos":"S8-z","image":"T8-z","paperCutDisabledOverlay":"U8-z"};